module.exports = __webpack_public_path__ + "img/DSC_2906-xl.8d6e7fab.png";